<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.39502 1.305C1.80401 1.305 1.32502 1.78399 1.32502 2.375V11.625C1.32502 12.216 1.80401 12.695 2.39502 12.695H11.655C12.246 12.695 12.725 12.216 12.725 11.625V9.80501H14.025V11.625C14.025 12.934 12.964 13.995 11.655 13.995H2.39502C1.08604 13.995 0.0250244 12.934 0.0250244 11.625V2.375C0.0250244 1.06602 1.08604 0.00500488 2.39502 0.00500488H11.645C12.954 0.00500488 14.015 1.06602 14.015 2.375V4.195H12.715V2.375C12.715 1.78399 12.236 1.305 11.645 1.305H2.39502Z"
			fill="#646E87"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.585 4.84501C10.464 4.84501 10.365 4.94399 10.365 5.065V8.93501C10.365 9.05602 10.464 9.155 10.585 9.155H14.455C14.576 9.155 14.675 9.05602 14.675 8.93501V5.065C14.675 4.94399 14.576 4.84501 14.455 4.84501H10.585ZM9.06502 5.065C9.06502 4.22602 9.74604 3.545 10.585 3.545H14.455C15.294 3.545 15.975 4.22602 15.975 5.065V8.93501C15.975 9.77399 15.294 10.455 14.455 10.455H10.585C9.74604 10.455 9.06502 9.77399 9.06502 8.93501V5.065Z"
			fill="#646E87"
		/>
	</svg>
</template>
<script>
export default { name: 'CustomerFeaturesSVG' };
</script>
